__webpack_require__.p = "/e-commerce_full_dashboard/";